import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

interface EducationInfo {
  schoolName: string;
  location: string;
  degree: string;
  graduationYear: number;
}

interface MilitaryService {
  period: string;
  location: string;
  duties: string;
}

interface Course {
  courseName: string;
  institution: string;
  certificateName: string;
  date: string;
}

interface LanguageSkill {
  language: string;
  readingWriting: 'ORTA' | 'IYI' | 'COK_IYI';
  speaking: 'ORTA' | 'IYI' | 'COK_IYI';
}

interface ComputerSkill {
  programName: string;
  level: 'ORTA' | 'IYI' | 'COK_IYI';
}

interface DriverLicense {
  class: string;
  issuedPlace: string;
  date: string;
  number: string;
}

interface WorkExperience {
  company: string;
  position: string;
  startDate: string;
  endDate: string;
  reasonForLeaving: string;
}

interface Reference {
  name: string;
  occupation: string;
  relationship: string;
  phone: string;
}

export class CareerFormDto {
  id: string;
  position: string;
  fullName: string;
  birthDate: string;
  birthPlace: string;
  address: string;
  createdAt: string;
  phone: string;
  email: string;
  education: {
    primarySchool: EducationInfo;
    middleSchool: EducationInfo;
    highSchool: EducationInfo;
    university: EducationInfo;
  };
  militaryStatus: 'YAPTI' | 'YAPMADI';
  militaryDefermentDate?: string;
  militaryServices?: MilitaryService[];
  courses?: Course[];
  languages?: LanguageSkill[];
  computerSkills?: ComputerSkill[];
  driverLicenses?: DriverLicense[];
  workExperiences?: WorkExperience[];
  maritalStatus: string;
  numberOfChildren: number;
  dependents: string;
  pastIllnesses: string;
  currentHealthStatus: string;
  expectedSalary: number;
  references?: Reference[];
  notes?: string[];
}

export class CareerFormListResponse extends IPagination {
  @Type(() => CareerFormDto)
  results: CareerFormDto[];
}

export class CareerFormResponse {
  @Type(() => CareerFormDto)
  result: CareerFormDto;
}

export class CareerFormFilterQueryDto extends IQueryPaginationDto {
  position?: string;
  name?: string;
  surname?: string;
  fullName?: string;
}
